import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebase from 'firebase';
import  'firebase/auth'
import 'firebase/database'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueMeta from 'vue-meta'
import SocialSharing from 'vue-social-sharing'
import VueCarousel from '@chenfengyuan/vue-carousel';
import VeeValidate from 'vee-validate';

Vue.use(VueMeta)
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueCarousel);
Vue.use(SocialSharing);
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  inject: true,
  fieldsBagName: "veeFields",
  errorBagName: "veeErrors"
});
var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  container: "body",
  duration: 1500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.config.productionTip = false
firebase.initializeApp({
  apiKey: "AIzaSyBjXFgMdlIRnVgQwdAnaRoqpW5rSY6Y0MQ",
  authDomain: "psyhologia-84b01.firebaseapp.com",
  databaseURL: "https://psyhologia-84b01.firebaseio.com",
  projectId: "psyhologia-84b01",
  storageBucket: "psyhologia-84b01.appspot.com",
  messagingSenderId: "565694020744",
  appId: "1:565694020744:web:a63bbcb51f93653dc2f33d"
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
